import request from '@/utils/request'

export const fetchSelectionDetail = (id) => {
  return request({
    url: `/sol/wap/biz_list/${id}`,
    method: 'get'
  })
}

export const fetchSolutions = (id, params) => {
  return request({
    url: `/sol/wap/biz_list/${id}/solutions`,
    method: 'get',
    params
  })
}

export const fetchTagList = (bizId) => {
  return request({
    url: `/sol/common/${bizId}/dictDataByType`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/selection/selection.js